module.exports = __webpack_public_path__ + "static/media/modalButton--startAgain.221535e6.svg";